import api from './api';

const notificationService = {
  getAllNotifications: (params) => api.get('/notifications/admin/all', { params }),
  sendNotification: (data) => api.post('/notifications/admin/send', data),
  broadcastNotification: (data) => api.post('/notifications/admin/broadcast', data),
};

export default notificationService;
